import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import { useTheme } from "styled-components";
import Svg from "../Svg";
var Icon = function(props) {
    var theme = useTheme();
    var primaryColor = theme.isDark ? " rgba(236, 228, 253, 0.1)" : "#0B3D91";
    var secondaryColor = theme.isDark ? " rgba(164, 175, 193, 1)" : "white";
    return /*#__PURE__*/ _jsx(Svg, _object_spread_props(_object_spread({
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: /*#__PURE__*/ _jsxs("svg", {
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ _jsxs("g", {
                    clipPath: "url(#clip0_2663_25112)",
                    children: [
                        /*#__PURE__*/ _jsx("path", {
                            d: "M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z",
                            fill: primaryColor
                        }),
                        /*#__PURE__*/ _jsx("path", {
                            d: "M33.3337 19.9998C33.3337 18.3858 32.0238 17.0758 30.4098 17.0758C29.6145 17.0758 28.9127 17.3799 28.3981 17.8946C26.4098 16.4677 23.6495 15.532 20.6086 15.415L21.9419 9.16941L26.2694 10.0817C26.3162 11.1811 27.2285 12.07 28.3513 12.07C29.4975 12.07 30.4332 11.1343 30.4332 9.98812C30.4332 8.84192 29.4975 7.90625 28.3513 7.90625C27.5326 7.90625 26.8308 8.37409 26.5033 9.07584L21.6612 8.0466C21.5209 8.02321 21.3805 8.0466 21.2636 8.11678C21.1466 8.18695 21.0764 8.30391 21.0297 8.44426L19.556 15.415C16.4449 15.5086 13.6612 16.4209 11.6495 17.8946C11.1349 17.4033 10.4098 17.0758 9.63784 17.0758C8.02381 17.0758 6.71387 18.3858 6.71387 19.9998C6.71387 21.1928 7.41562 22.1986 8.44486 22.6665C8.39808 22.9472 8.37469 23.2513 8.37469 23.5554C8.37469 28.0466 13.5911 31.6723 20.0472 31.6723C26.5033 31.6723 31.7197 28.0466 31.7197 23.5554C31.7197 23.2513 31.6963 22.9706 31.6495 22.6899C32.6086 22.222 33.3337 21.1928 33.3337 19.9998ZM13.3337 22.0817C13.3337 20.9355 14.2694 19.9998 15.4156 19.9998C16.5618 19.9998 17.4975 20.9355 17.4975 22.0817C17.4975 23.2279 16.5618 24.1636 15.4156 24.1636C14.2694 24.1636 13.3337 23.2279 13.3337 22.0817ZM24.9595 27.5788C23.5326 29.0057 20.8191 29.0992 20.0238 29.0992C19.2285 29.0992 16.4916 28.9823 15.0881 27.5788C14.8776 27.3682 14.8776 27.0174 15.0881 26.8068C15.2987 26.5963 15.6495 26.5963 15.8601 26.8068C16.749 27.6957 18.6671 28.0232 20.0472 28.0232C21.4273 28.0232 23.3221 27.6957 24.2343 26.8068C24.4449 26.5963 24.7957 26.5963 25.0063 26.8068C25.17 27.0408 25.17 27.3682 24.9595 27.5788ZM24.5852 24.1636C23.439 24.1636 22.5033 23.2279 22.5033 22.0817C22.5033 20.9355 23.439 19.9998 24.5852 19.9998C25.7314 19.9998 26.6671 20.9355 26.6671 22.0817C26.6671 23.2279 25.7314 24.1636 24.5852 24.1636Z",
                            fill: secondaryColor
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx("defs", {
                    children: /*#__PURE__*/ _jsx("clipPath", {
                        id: "clip0_2663_25112",
                        children: /*#__PURE__*/ _jsx("rect", {
                            width: "40",
                            height: "40",
                            fill: secondaryColor
                        })
                    })
                })
            ]
        })
    }));
};
export default Icon;
